import React, { ReactNode } from 'react';
import { Icon } from '../icon/SwIcon.constants';
import { SwIcon } from '../icon/SwIcon';

type Props = { children: ReactNode };

export const SwFormRequiredLegend = ({ children }: Props) => (
  <div
    aria-hidden="true"
    className="vl-u-bg-alt vl-alert--small vl-u-spacer--medium"
    style={{
      border: 'none',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <SwIcon icon={Icon.INFO_CIRCLE} />
    <p
      className="vl-form__annotation"
      style={{
        margin: '0 0 0 1rem',
      }}
    >
      {children}
    </p>
  </div>
);
